import {
  DISTANCE_UNIT_VALUES,
  DISTANCE_UNITS,
  SPEED_UNITS,
} from "../pages/admin-details/account/constants";

// the unit's display suffix, so a formatted speed reads the same wherever
// it is shown
export const speedUnitSuffix = (unit: SPEED_UNITS) => {
  switch (unit) {
    case SPEED_UNITS.KMH:
      return "km/h";
    case SPEED_UNITS.NAUTICAL_MILES:
      return "kn";
    case SPEED_UNITS.MPH:
    default:
      return "mph";
  }
};

export const convertKmphTo = (to: SPEED_UNITS, kmph: number) => {
  switch (to) {
    case SPEED_UNITS.KMH:
      return kmph;
    case SPEED_UNITS.NAUTICAL_MILES:
      return kmph / 1.852;
    case SPEED_UNITS.MPH:
    default:
      return kmph / 1.60934;
  }
};

export const convertSpeedToKmph = (from: SPEED_UNITS, speed: number) => {
  switch (from) {
    case SPEED_UNITS.NAUTICAL_MILES:
      return speed * 1.852;
    case SPEED_UNITS.MPH:
      return speed * 1.60934;
    case SPEED_UNITS.KMH:
    default:
      return speed;
  }
};

export const convertMetersTo = (to: DISTANCE_UNITS, meters: number) => {
  switch (to) {
    case DISTANCE_UNITS.KM:
      return meters / 1000;
    case DISTANCE_UNITS.NAUTICAL_MILES:
      return meters / 1852;
    case DISTANCE_UNITS.MILES:
    default:
      return meters / 1609.34;
  }
};
export const convertToMetersForApi = (
  from: DISTANCE_UNITS,
  value: number
): number => {
  switch (from) {
    case DISTANCE_UNITS.KM:
      return value * 1000;
    case DISTANCE_UNITS.NAUTICAL_MILES:
      return value * 1852;
    case DISTANCE_UNITS.MILES:
      return value * 1609.34;
    default:
      return value;
  }
};
export const convertMetersToFeet = (meters: number): number => {
  return meters * 3.28084;
};

export const convertFeetToMetersForApi = (feet: number): number => {
  return feet / 3.28084;
};

export const accountDistanceUnit = (unit: DISTANCE_UNITS) => {
  switch (unit) {
    case DISTANCE_UNITS.KM:
      return "km";
    case DISTANCE_UNITS.NAUTICAL_MILES:
      return "nmi";
    case DISTANCE_UNITS.MILES:
    default:
      return "mi";
  }
};

// Number of decimal places to round off to
export const MAINTENANCE_ROUND_OFF = 2;

// Return a number rounded off to a specific number of decimal places(if in decimal)
export const getRoundedOffValue = (value: number) => {
  return value % 1 === 0 ? value : value.toFixed(MAINTENANCE_ROUND_OFF);
};

// Convert distance(In KMs) to specific unit
export const getDistanceByUnit = (
  distanceInKms: number,
  unit: DISTANCE_UNIT_VALUES
) => {
  switch (unit) {
    case DISTANCE_UNIT_VALUES.NAUTICAL_MILES:
      return Number(getRoundedOffValue(distanceInKms / 1.852));
    case DISTANCE_UNIT_VALUES.MILES:
      return Number(getRoundedOffValue(distanceInKms / 1.60934));
    case DISTANCE_UNIT_VALUES.KM:
    default:
      return Number(getRoundedOffValue(distanceInKms));
  }
};

// Convert distance(In KMs) to specific unit without rounding it
export const getDistanceByUnitUnrounded = (
  distanceInKms: number,
  unit: DISTANCE_UNIT_VALUES
) => {
  switch (unit) {
    case DISTANCE_UNIT_VALUES.NAUTICAL_MILES:
      return Number(distanceInKms / 1.852);
    case DISTANCE_UNIT_VALUES.MILES:
      return Number(distanceInKms / 1.60934);
    case DISTANCE_UNIT_VALUES.KM:
    default:
      return Number(distanceInKms);
  }
};

// Convert distance in specific unit to KMs
export const getDistanceInKms = (
  distance: number,
  unit: DISTANCE_UNIT_VALUES
) => {
  switch (unit) {
    case DISTANCE_UNIT_VALUES.NAUTICAL_MILES:
      return distance * 1.852;
    case DISTANCE_UNIT_VALUES.MILES:
      return distance * 1.60934;
    case DISTANCE_UNIT_VALUES.KM:
    default:
      return distance;
  }
};

// Convert distance(In KMs) to specific unit
export const getLabelByUnit = (unit: DISTANCE_UNIT_VALUES) => {
  switch (unit) {
    case DISTANCE_UNIT_VALUES.NAUTICAL_MILES:
      return "label_nautical_miles";
    case DISTANCE_UNIT_VALUES.MILES:
      return "label_miles";
    case DISTANCE_UNIT_VALUES.KM:
    default:
      return "label_kms";
  }
};
